/**
 * Which credit label the Chat section shows beside *Always create AI copy* (PREC-3687 §4.3 / D11).
 *
 * The input is the API's derived `isCopywritingIncluded` flag, **not** the list's source type: the
 * exemption is a billing fact (`CopywritingCreditsService` charges 0 once a deep-research response
 * exists), and the API owns which lists it currently holds for. Re-deriving "tracker ⇒ free" in the
 * browser would fork that rule and silently go stale the day another source type earns the
 * exemption.
 *
 * Returns an i18n key rather than a sentence so the caller stays the only place that translates.
 */
export const copywritingCreditLabelKey = (isCopywritingIncluded: boolean): string =>
	isCopywritingIncluded
		? "list.outreach.chat.credit.included"
		: "list.outreach.chat.credit.perLead";
